<template>
    <div class="row">
        <div class="col-12">
            <div class="btn-group w-100">
                <button type="button"
                    @click="$emit('click')" 
                    class="btn bg-secondary bg-opacity-25 w-100 text-start">
                    <table class="table table-sm p-0 m-0">
                        <tbody>
                    <tr><td class="w-50 p-0 bg-transparent">
                        <div class="p-0"><small>Client: {{ view.client }}</small></div>
                        <div class="p-0"><small>Job: {{ view.job }}</small></div>
                    </td>
                    <td class="w-50 p-0 text-end bg-transparent">
                        <div class="p-0"><small>Status:</small></div>
                        <!-- TODO ... -->
                        <div class="p-0"><small>ALL</small></div>
                    </td>
                    </tr>
                </tbody>
                    </table>
                </button>
                <button type="button"
                    @click="$emit('click')" 
                    class="btn btn-secondary px-4"
                ><i class="fa fa-chevron-right"></i></button></div>
        </div>
        <div class="col-12">
            <div class="btn-group w-100 mt-1">
                <button type="button" 
                    @click="$emit('click')"
                    class="btn bg-secondary bg-opacity-25 w-100 text-start">
                    <table class="table table-sm p-0 m-0">
                        <tbody>
                    <tr>
                        <td class="w-50 p-0 bg-transparent">
                            <div class="p-0"><small>Dates:</small></div>
                            <div class="p-0"><small>{{ view.dates }}</small></div>
                        </td>
                        <td class="w-50 p-0 text-end bg-transparent">
                            <div class="p-0"><small>User:</small></div>
                            <div class="p-0"><small>{{ view.user }}</small></div>
                        </td>
                    </tr>
                </tbody>
                    </table>
                </button>
                <button type="button" 
                    @click="$emit('click')"
                    class="btn btn-secondary px-4">
                    <i class="fa fa-chevron-right"></i>
                </button>
            </div>
        </div>
        <div class="col">
            <div class="btn-group w-100 mt-1">
                <button type="button" class="btn bg-secondary bg-opacity-10">
                    <small>{{ props.count }} of {{ props.total }} Records</small>
                </button>
                <!-- 
                <button type="button" class="btn bg-secondary bg-opacity-10">
                    <small># Hours</small>
                </button>
                -->
                <!--
                <button type="button" class="btn bg-secondary bg-opacity-10">
                    <small>${{ props.money }}</small>
                </button>
                -->
            </div>
        </div>
    </div>
</template>
    
<script setup>

import { ref, watch } from "vue";
import { useClientStore } from "@/stores/ClientStore";
import { useTechStore } from "@/stores/TechStore";
import Api from "@/services/Api";
import Attic from "@/services/Attic";

const view = ref ({
    client: "",
    job: "",
    status: "",
    user: ""
});

const props = defineProps([
    "filter",
    "count",
    "total",
    "hours",
    "money",
]);

const getUser = async (user) =>
{

    if (!user) {
        view.value.user = "ALL";
        return;
    }

    let users = useTechStore();
    let tc = await users.getById(user);
    view.value.user = tc && tc.TechnicianName || user;
};

const getStatus = (status) =>
{
    if (!status) {
        view.value.status = "ALL";
        return;
    }

    let st = Attic.GetTaskStatus(status);
    view.value.status = st && st.label || status;
};

const getClient = async (client) =>
{
    if (!client) {
        view.value.client = "ALL";
        return;
    };

    let clients = useClientStore();
    let cl = await clients.getByCustomerNumber(client);
    view.value.client = cl && cl.Company || client;
};

const getJob = async (job) =>
{
    if (!job)
    {
        view.value.job = "ALL";
        return;
    }

    let j = await Api.loadJob(job);
    view.value.job = j && j.RequestDetailedDescription || j.TaskDetail || job;  
};

const getDates = async (start, end) =>
{
    view.value.dates = start + " - " + end;
};

watch(() => {
    return JSON.stringify(props.filter)
}, (nv, ov) => {
    if (nv) {
        getUser(props.filter.user);
        // getStatus(props.filter.status);
        getClient(props.filter.client);
        getJob(props.filter.job);
        getDates(props.filter.startDate, props.filter.endDate);
    }
}, { immediate:true });

defineEmits(["click"]);
    
</script>